module.exports = __webpack_public_path__ + "cbeb7afa1c682f9c236c6219c3feb9f5.svg";